import axios from 'axios'

export default {
  // 캘린더 시공 정보 불러오기
  getSchedule (data, cb) {
    const url = `/biz/solarhome/customer/schedule/?year=${data.year}&start=${data.start}&end=${data.end}`
    axios.get(url, {params: {format: 'json'}})
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response)
        } else {
          cb(response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 알람 정보 불러오기
  getAlarm (cb) {
    const url = '/biz/solarhome/alarm/'
    axios.get(url, {format: 'json'})
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response)
        } else {
          cb(response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 알람을 읽음상태로 변경하기
  readAlarm (id, cb) {
    const url = '/biz/solarhome/alarm/' + id + '/'
    axios.put(url, {
      format: 'json',
      is_read: true
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response)
        } else {
          cb(response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 단계별 현황 불러오기
  getSteps (cb) {
    const url = '/biz/solarhome/customer/step_stats/?year=2018'
    axios.get(url, {format: 'json'})
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          let total = 0
          let arr = Object.values(response.data.step)

          // 단계별 현황에 전체 데이터가 없으므로 step에 모든 값을 더해 반환
          for (let i in arr) {
            total += arr[i]
          }
          response.data.step['전체'] = total

          cb(response)
        } else {
          cb(response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 고객정보 불러오기
  getCustomer (id, cb) {
    // 프로젝트 정보 가져오기
    axios.get('/biz/solarhome/new_customer/' + id + '/', {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response.data)
        } else {
          console.log('loading fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  saveCustomer (data, cb) {
    // ID가 없을 경우, 신규등록
    if (typeof data.id === 'undefined') {
      axios.post('/biz/solarhome/customer/', data).then(function (response) {
        if (response.status === 201) {
          cb(response)
        } else {
          console.log('create Customer fail!')
        }
      }).catch(function (response) {
        response.error = true
        cb(response)
      })
    } else {
      // ID가 있을 경우, 정보수정
      const url = `/biz/solarhome/customer/${data.id}/`
      axios.put(url, data).then(function (response) {
        if (response.status === 200) {
          cb(response)
        } else {
          console.log('edit Customer fail!', response)
        }
      }).catch(function (response) {
        response.error = true
        cb(response)
      })
    }
  },

  saveStep (data, cb) {
    const url = `/biz/solarhome/customer/${data.id}/change_step/`
    const param = { to: data.select_step }
    axios.post(url, param)
      .then(function (response) {
        if (response.status === 200) {
          cb(response)
        } else {
          console.log('update step fail!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 다음 진행단계에 대한 next_require 목록 가져오기
  getRequired (data, cb) {
    axios.get('/biz/solarhome/customer/step_required/?from=' + data.from + '&&to=' + data.to)
      .then(function (response) {
        if (response.status === 200) {
          cb(response.data)
        } else {
          console.log('loading fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/solarhome.js